import { IVehicleFromUsers } from '../user/vehicle-from-users.interface';

export interface IGarageResponse {
  vehicles: IVehicleFromUsers[];
}
